import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Header></Header>
      <Footer></Footer>
    </div>
  );
}

export default App;
